import moment from 'moment'

// Set utils function parseTime to filter
export { parseTime } from '@/utils'

export const parseUtc = (utcTime: string): string => {
  const result = moment.utc(utcTime).format('YYYY-MM-DD')
  return result === 'Invalid date' ? '' : result
}

export const parseDateTime = (utcTime: string): string => {
  const result = moment.utc(utcTime).local().format('YYYY-MM-DD hh:mm A')
  return result === 'Invalid date' ? '' : result
}

// Filter for article status
export const articleStatusFilter = (status: string) => {
  const statusMap: { [key: string]: string } = {
    published: 'success',
    draft: 'info',
    deleted: 'danger'
  }
  return statusMap[status]
}

// Filter to uppercase the first character
export const uppercaseFirstChar = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const inspectionTypeAbbrv = (inspectionType: number) => {
  const typeMap: { [key: number]: string } = {
    1: 'Exterior',
    2: 'Int & Ext',
    3: 'Floorplan',
    4: 'No Insp.',
    5: 'Int/Ext No Fp',
    6: 'PDR',
    7: 'PDR No Fp',
    8: 'Site PDR',
    9: 'FNMA V5',
    10: 'Test App',
    11: 'FNMA V6',
    12: 'Disaster',
    13: 'Bungalow',
    14: 'Exterior V2',
    15: 'ACE+ PDR V2',
    16: 'Int/Ext V2',
    17: 'FP Only V2',
    18: 'FNMA UPD'
  }
  return typeMap[inspectionType] || 'Order Type ' + inspectionType
}

export const stateFilter = (st: string) => {
  return st.length > 2 ? '' : st
}

export const phoneFilter = (ph: string) => {
  const val = ph.replace(/\D[^\\.]/g, '')
  if (val.length === 10) {
    return val.slice(0, 3) + '-' + val.slice(3, 6) + '-' + val.slice(6)
  }
  return ph
}

export const distance = (distance: number): string => {
  if (isNaN(distance)) return 'Unknown'
  return distance.toFixed(1)
}

export const fixed2 = (v: number): string => {
  if (isNaN(v)) return 'Unknown'
  return v.toFixed(2)
}

export const fixed3 = (v: number): string => {
  if (isNaN(v)) return 'Unknown'
  return v.toFixed(2)
}

export const currency0 = (value: number): string => {
  // return '$' + curr.toFixed(0)
  if (isNaN(value)) {
    return ''
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
}

export const notset = (v: string) => {
  return (v === null || v === '') ? 'Not set' : v
}

export const uppercase = (value: string): string => {
  if (!value) return ''
  return value.toUpperCase()
}
